import { Link } from "react-router-dom";
import { CheckCircle2, ImageIcon } from "lucide-react";
import { fileUrl, ghs } from "../../lib/api";

export const ProductImage = ({ path, alt, className = "" }) =>
  path ? (
    <img src={fileUrl(path)} alt={alt} loading="lazy" className={`h-full w-full object-cover ${className}`} />
  ) : (
    <div className={`grid h-full w-full place-items-center bg-[radial-gradient(circle_at_30%_20%,rgba(16,185,129,0.18),transparent_60%),#0d1320] ${className}`}>
      <ImageIcon className="text-slate-600" size={36} />
    </div>
  );

export const ProductCard = ({ product, category, owned, base = "/products" }) => (
  <article data-testid={`product-card-${product.id}`} className="card-rx card-hover group flex flex-col overflow-hidden">
    <Link to={`${base}/${product.id}`} className="relative block aspect-[4/3] overflow-hidden">
      <ProductImage path={product.image_path} alt={product.name} className="transition-transform duration-500 group-hover:scale-105" />
      {category && (
        <span className="absolute left-3 top-3 rounded-full bg-black/60 px-2.5 py-1 text-[11px] font-semibold text-slate-200 backdrop-blur">
          {category}
        </span>
      )}
      {owned && (
        <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-emerald-500 px-2.5 py-1 text-[11px] font-bold text-[#06110c]">
          <CheckCircle2 size={12} /> Purchased
        </span>
      )}
    </Link>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="text-lg font-semibold text-white">{product.name}</h3>
      <p className="mt-1.5 line-clamp-2 flex-1 text-sm text-slate-400">{product.short_description || "Digital product"}</p>
      <div className="mt-5 flex items-center justify-between">
        <span className="font-mono-rx text-base font-semibold text-amber-400" data-testid={`product-price-${product.id}`}>
          {ghs(product.price_minor)}
        </span>
        <Link to={`${base}/${product.id}`} className="btn-ghost px-4 py-2" data-testid={`product-view-${product.id}`}>
          {owned ? "View" : "Buy"}
        </Link>
      </div>
    </div>
  </article>
);
